import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

let caps = null;
export const getEmailCaps = async () => {
  if (!caps) caps = api.get("/email/capabilities").then(({ data }) => data).catch(() => { caps = null; return { simulation: false, brevo: false }; });
  return caps;
};

const STATE_MSG = {
  brevo_accepted: "Envoi accepté par Brevo",
  brevo_failed: "Échec du renvoi Brevo",
  brevo_unknown: "Brevo n'a pas répondu : résultat inconnu",
};

// Explicit, confirmed resend of one refused recipient via Brevo
export const resendViaBrevo = async (quoteId, to) => {
  if (!window.confirm(`Renvoyer ce devis via Brevo à ${to} uniquement ?`)) return null;
  const tid = toast.loading("Renvoi via Brevo…");
  try {
    const { data } = await api.post(`/quotes/${quoteId}/resend-brevo`, { to });
    const msg = data.simulated ? "Accepté par Brevo (simulé) : aucun e-mail n'est parti" : STATE_MSG[data.state] || data.state;
    (data.ok ? toast.success : toast.error)(data.message && !data.ok ? `${msg} — ${data.message}` : msg, { id: tid });
    return data;
  } catch (err) {
    toast.error(formatApiErrorDetail(err.response?.data?.detail), { id: tid });
    return null;
  }
};

// Notifications after a quote PDF send: simulation and refused recipients (with optional Brevo action)
export const notifySendResult = (quoteId, data, onResent) => {
  if (data.simulated) toast.info("Envoi simulé : aucun e-mail n'est parti", { duration: 8000 });
  (data.refused || []).forEach((to) => toast.error(`Refusée par le service d'envoi : ${to}`, {
    duration: 15000,
    ...(data.brevo ? { action: { label: "Réessayer via Brevo", onClick: async () => { const r = await resendViaBrevo(quoteId, to); if (r && onResent) onResent(r); } } } : {}),
  }));
};
